import { SupabaseLoadMemberContextRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadMemberContext } from '@/shared/domain'

export function makeLoadMemberContext(): LoadMemberContext {
  return new SupabaseLoadMemberContextRepository(makeSupabaseEdgeHttpClient()).execute
}
